import { writable } from "svelte/store"

export const ImageQuotePrefs = new (class {
    readonly boldParagraph = writable(false)
    readonly paragraphNumbers = writable(false)
    readonly sentenceNumbers = writable(false)
    constructor() {}
})()
